/**
 * Images should be stored in the `App/Images` directory and referenced using variables defined here.
 */

export default {
  logo: require('../Assets/svgs/logo.svg'),
  whiteLogo: require('../Assets/images/whiteLogo.png'),
  visionLogo: require('../Assets/images/visionWhiteLogo.png'),
  demoBanner: require('../Assets/svgs/demoBanner.svg'),
  bgImage: require('../Assets/images/yellowBg.jpg'),
  iso: require('../Assets/images/iso.png'),
}